import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Open the dialog from the center from the screen", -1)
const _hoisted_2 = { class: "dialog-footer" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountInfo',
  setup(__props, { expose: __expose }) {

const dialogRef = ref(false);

const show = () => {
  dialogRef.value = true;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogRef).value = $event)),
    title: "Account Info",
    width: "1000",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})